<script setup lang="ts">
import { getCategoryRoute } from '@shopware/helpers'

const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)

const {
    navigationItems,
    openedCategory,
    openPopover,
    closePopover,
} = useMegaMenu()

const NO_POPOVER_NAMES = [
    'Marken',
    'New In',
]
</script>

<template>
    <nav
        itemscope
        itemtype="https://schema.org/SiteNavigationElement"
        :aria-label="$t('megaMenu.title')"
        class="w-full relative"
    >
        <div class="w-full">
            <ul class="flex justify-center items-center flex-wrap">
                <li
                    v-for="item in navigationItems ?? []"
                    :key="item.id"
                    class="btn btn-no-animation px-3 py-0 gap-x-2 h-[69px] border-0 group"
                    @mouseenter.passive="item.children.length && !NO_POPOVER_NAMES.includes(item.name) ? openPopover(item.id) : closePopover()"
                >
                    <FoundationLink
                        :href="formatLink(getCategoryRoute(item))"
                        itemprop="url"
                        class="btn h-full px-0 py-3 uppercase border-2 border-transparent group-hover:border-b-primary"
                        active-class="border-b-primary"
                        @click="closePopover()"
                    >
                        <span itemprop="name">{{ item.name }}</span>
                    </FoundationLink>

                    <FoundationButton
                        v-if="item.children.length && !NO_POPOVER_NAMES.includes(item.name)"
                        square
                        size="small"
                        :aria-expanded="openedCategory === item.id"
                        :aria-controls="`menu-${item.id}`"
                        class="w-auto"
                        @click="openPopover(item.id, { delay: 0 })"
                    >
                        <span class="sr-only">{{ $t('megaMenu.firstLevel.openChildren', { category: item.name }) }}</span>
                        <FoundationIcon :name="openedCategory === item.id ? 'chevron-up' : 'chevron-down'" />
                    </FoundationButton>
                </li>
            </ul>
        </div>
    </nav>
</template>
